import {Injectable} from '@angular/core';
import {Http, Response, Headers} from "@angular/http";
import 'rxjs/Rx';



@Injectable()
export class PushNotificationService {

  url: any = 'https://onesignal.com/api/v1/notifications';


  constructor(private http: Http) {
  }

  sendNotification(message) {
    const body = JSON.stringify(message);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    // copy your Rest api key below ;
    headers.append('Authorization', 'Basic YjYxMDdmYjMtNWE3Ni00MWQyLWE1ZTEtMDlmYzc2MTczYzJm');
    return this.http.post(this.url, body, {
      headers: headers
    }).map((data: Response) => data.json())

  }
}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/push-notification/push-notification.service.ts